<ng-template #settingsTemplate>
    <app-tool-setting label="Verdeling">
        <app-range-slider
            [min]="1"
            [max]="20"
            [(range)]="distribution"
        ></app-range-slider>
    </app-tool-setting>
    <app-tool-setting label="Opties">
        <app-check-box
            [checked]="showNumbers"
            (checkedChange)="toggleShowNumbers()"
            label="getallen"
        ></app-check-box>
        <app-check-box
            [checked]="showUnits"
            (checkedChange)="toggleshowUnits()"
            label="honderdstructuur"
        ></app-check-box>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 292.88 282.81"
        style="width: 300px"
    >
        <defs>
            <style>
                .percentRing-white {
                    fill: #fff;
                }
                .percentRing-1 {
                    fill: none;
                    stroke: #0091d5;
                    stroke-miterlimit: 10;
                    stroke-width: 1.5px;
                }
                .percentRing-2 {
                    fill: #0091d5;
                }
                .percentRing-3 {
                    font-size: 16px;
                    font-family: UniversLTStd, Univers LT Std;
                }
            </style>
        </defs>
        <title>procentenring</title>
        <g id="white_BG" data-name="white BG">
            <circle class="percentRing-white" cx="146" cy="142" r="125" />
        </g>
        @if (distribution === 2) {
        <g id="_2" data-name="2">
            <path
                class="percentRing-1"
                d="M150,150V275a125,125,0,0,1,0-250h0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25a125,125,0,0,1,0,250h0Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 3) {
        <g id="_3" data-name="3">
            <path
                class="percentRing-1"
                d="M150,150,41.77,212.48A125,125,0,0,1,87.52,41.75,119.4,119.4,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l108.24,62.49A125,125,0,0,1,87.52,258.23a119.42,119.42,0,0,1-45.75-45.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25A125,125,0,0,1,275,150a119.4,119.4,0,0,1-16.75,62.49Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 4) {
        <g id="_4" data-name="4">
            <path
                class="percentRing-1"
                d="M150,150H25A125,125,0,0,1,150,25h0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275A125,125,0,0,1,25,150H150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H275A125,125,0,0,1,150,275h0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25A125,125,0,0,1,275,150H150Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 5) {
        <g id="_5" data-name="5">
            <path
                class="percentRing-1"
                d="M150,149.76,31.37,111.22C48.4,58.81,94.89,25,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.76,76.69,250.67c-44.59-32.39-62.35-87-45.32-139.45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.76l73.31,100.91c-44.58,32.39-102,32.39-146.62,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.76l118.63-38.54c17,52.41-.73,107.06-45.32,139.45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.76V25c55.11,0,101.6,33.78,118.63,86.19Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 6) {
        <g id="_6" data-name="6">
            <path
                class="percentRing-1"
                d="M150,150,42.17,87.5C65.07,47.68,104.2,25,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,42.17,212.5c-22.89-39.82-22.89-85.18,0-125Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275c-45.8,0-84.93-22.68-107.83-62.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l107.83,62.5C234.93,252.32,195.8,275,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,257.83,87.5c22.89,39.82,22.89,85.18,0,125Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25c45.8,0,84.93,22.68,107.83,62.5Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 7) {
        <g id="_7" data-name="7">
            <path
                class="percentRing-1"
                d="M150,149.73,51.76,72.94C76,41.94,110.69,25,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.73,28.52,177.78c-8.85-38.32-1-73.85,23.24-104.84Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.73l-52.7,113c-35.64-16.62-60-46.65-68.8-85Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.73l54.66,112.1c-35.34,17.24-71.72,17.56-107.36.93Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.73l122,25.93c-8.18,38.47-32,68.93-67.31,86.17Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.73l96.9-78.5c24.75,30.57,33.24,66,25.07,104.43Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.73V25c39.32,0,72.16,15.67,96.9,46.23Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 8) {
        <g id="_8" data-name="8">
            <path
                class="percentRing-1"
                d="M150,150,61.61,61.61Q98.23,25,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H25q0-51.78,36.61-88.39Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,61.61,238.39Q25,201.77,25,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275q-51.78,0-88.39-36.61Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l88.39,88.39Q201.77,275,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H275q0,51.78-36.61,88.39Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l88.39-88.39Q275,98.23,275,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25q51.78,0,88.39,36.61Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 9) {
        <g id="_9" data-name="9">
            <path
                class="percentRing-1"
                d="M150,149.84,69.77,54.21C93.22,34.53,119.39,25,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84,27.08,128.16C32.4,98,46.32,73.88,69.77,54.21Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84,41.91,212.26c-15.31-26.51-20.14-53.95-14.83-84.1Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84,107.31,267.15c-28.76-10.47-50.1-28.38-65.4-54.89Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84l42.69,117.31c-28.76,10.47-56.62,10.47-85.38,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84l108.09,62.42c-15.3,26.51-36.64,44.42-65.4,54.89Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84l122.92-21.68c5.31,30.15.48,57.59-14.83,84.1Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84l80.23-95.63c23.45,19.67,37.37,43.8,42.69,73.95Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.84V25c30.61,0,56.78,9.53,80.23,29.21Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 10) {
        <g id="_10" data-name="10">
            <path
                class="percentRing-1"
                d="M150,150,76.69,48.87C99,32.64,122.45,25,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,31.39,111.37c8.51-26.26,23-46.27,45.3-62.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,31.39,188.63c-8.52-26.27-8.52-51,0-77.26Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,76.69,251.13c-22.29-16.23-36.79-36.24-45.3-62.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275c-27.55,0-51-7.64-73.31-23.87Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l73.31,101.13C201,267.36,177.55,275,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l118.61,38.63c-8.51,26.26-23,46.27-45.3,62.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l118.61-38.63c8.52,26.27,8.52,51,0,77.26Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,223.31,48.87c22.29,16.23,36.79,36.24,45.3,62.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25c27.55,0,51,7.64,73.31,23.87Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 11) {
        <g id="_11" data-name="11">
            <path
                class="percentRing-1"
                d="M150,149.9,82,45.15A120.59,120.59,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9,35.92,99.1A120.63,120.63,0,0,1,82,45.15Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9,26.66,169.44A120.57,120.57,0,0,1,35.92,99.1Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9,55.75,231.85C39.33,213,30.58,194.18,26.66,169.44Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9,115.58,270a120.64,120.64,0,0,1-59.83-38.12Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9l36.51,119.45a120.64,120.64,0,0,1-70.94.62Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9l95.67,80.29a120.63,120.63,0,0,1-59.16,39.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9l123.67,17.39c-3.48,24.8-11.91,43.72-28,62.9Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9,263.19,97.12a120.61,120.61,0,0,1,10.49,70.17Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9,216.19,44a120.6,120.6,0,0,1,47,53.14Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.9V25c25,0,45,5.71,66.18,19Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 12) {
        <g id="_12" data-name="12">
            <path
                class="percentRing-1"
                d="M150,150,87.5,41.75A119.46,119.46,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,41.75,87.5A119.42,119.42,0,0,1,87.5,41.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H25A119.46,119.46,0,0,1,41.75,87.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,41.75,212.5A119.46,119.46,0,0,1,25,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,87.5,258.25A119.42,119.42,0,0,1,41.75,212.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275a119.46,119.46,0,0,1-62.5-16.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l62.5,108.25A119.46,119.46,0,0,1,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l108.25,62.5a119.42,119.42,0,0,1-45.75,45.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H275a119.46,119.46,0,0,1-16.75,62.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,258.25,87.5A119.46,119.46,0,0,1,275,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,212.5,41.75A119.42,119.42,0,0,1,258.25,87.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25a119.46,119.46,0,0,1,62.5,16.75Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 13) {
        <g id="_13" data-name="13">
            <path
                class="percentRing-1"
                d="M150,149.87,91.37,39.62A120.68,120.68,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,46.47,80a120.74,120.74,0,0,1,44.9-40.42Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,25.81,136.82A120.9,120.9,0,0,1,46.47,80Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,33.42,194.62c-7.59-19.76-9.82-36.74-7.61-57.8Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,68.07,244.11a120.67,120.67,0,0,1-34.65-49.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,121.9,271.54a120.67,120.67,0,0,1-53.83-27.43Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,180.19,271c-20.54,5.13-37.66,5.28-58.29.51Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87l83.54,92.8A120.62,120.62,0,0,1,180.19,271Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87l117.32,42.71a120.71,120.71,0,0,1-33.78,50.09Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87l123.92-15.22c2.58,21,.64,38-6.6,57.93Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,252.26,78.25a120.62,120.62,0,0,1,21.65,56.4Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87,206.67,38.61a120.7,120.7,0,0,1,45.59,39.64Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.87V25c21.17,0,37.82,4,56.68,13.61Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 14) {
        <g id="_14" data-name="14">
            <path
                class="percentRing-1"
                d="M150,150,94.43,37.65A124,124,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,50.11,73A122.22,122.22,0,0,1,94.43,37.65Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,26,124A120,120,0,0,1,50.11,73Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,26.48,178.12C22,159,21.86,143.26,26,124Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,51.48,228.67a120.25,120.25,0,0,1-25-50.55Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,96.43,263.29a122.28,122.28,0,0,1-45-34.62Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275c-19.95,0-35.49-3.4-53.57-11.71Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l55.57,112.35A124,124,0,0,1,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l99.89,77a122.22,122.22,0,0,1-44.32,35.39Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l124,26a120,120,0,0,1-24.11,51Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l123.52-28.12c4.49,19.17,4.62,34.86.48,54.11Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l98.52-78.67a120.25,120.25,0,0,1,25,50.55Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,203.57,36.71a122.28,122.28,0,0,1,45,34.62Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25c19.95,0,35.49,3.4,53.57,11.71Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 15) {
        <g id="_15" data-name="15">
            <path
                class="percentRing-1"
                d="M150,149.93,99.19,35.8A119.35,119.35,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,57.16,66.34a119.34,119.34,0,0,1,42-30.54Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,31.19,111.33a119.25,119.25,0,0,1,26-45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,25.76,163a119.28,119.28,0,0,1,5.43-51.66Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,41.81,212.4a119.38,119.38,0,0,1-16-49.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,76.57,251A119.3,119.3,0,0,1,41.81,212.4Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,124,272.14A119.37,119.37,0,0,1,76.57,251Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93l26,122.21a119.44,119.44,0,0,1-51.94,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,223.43,251A119.37,119.37,0,0,1,176,272.14Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,258.19,212.4A119.3,119.3,0,0,1,223.43,251Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,274.24,163a119.38,119.38,0,0,1-16.05,49.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93l118.81-38.6A119.28,119.28,0,0,1,274.24,163Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93l92.84-83.59a119.25,119.25,0,0,1,26,45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93,200.81,35.8a119.34,119.34,0,0,1,42,30.54Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.93V25a119.35,119.35,0,0,1,50.81,10.8Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 16) {
        <g id="_16" data-name="16">
            <path
                class="percentRing-1"
                d="M150,150,101.16,34.94A121.51,121.51,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,61.61,61.61a116.43,116.43,0,0,1,39.55-26.67Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,34.1,103.17A121.81,121.81,0,0,1,61.61,61.61Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H25a116.53,116.53,0,0,1,9.1-46.83Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,34.94,198.84A121.51,121.51,0,0,1,25,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,61.61,238.39a116.43,116.43,0,0,1-26.67-39.55Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,103.17,265.9a121.81,121.81,0,0,1-41.56-27.51Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275a116.53,116.53,0,0,1-46.83-9.1Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l48.84,115.06A121.51,121.51,0,0,1,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l88.39,88.39a116.43,116.43,0,0,1-39.55,26.67Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l115.9,46.83a121.81,121.81,0,0,1-27.51,41.56Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H275a116.53,116.53,0,0,1-9.1,46.83Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l115.06-48.84A121.51,121.51,0,0,1,275,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l88.39-88.39a116.43,116.43,0,0,1,26.67,39.55Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,196.83,34.1a121.81,121.81,0,0,1,41.56,27.51Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25a116.53,116.53,0,0,1,46.83,9.1Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 17) {
        <g id="_17" data-name="17">
            <path
                class="percentRing-1"
                d="M150,149.94,103.19,34.1A123.53,123.53,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,64.79,58.56a118.15,118.15,0,0,1,38.4-24.46Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,37.71,95.17A118.18,118.18,0,0,1,64.79,58.56Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,25.54,139.05A118.15,118.15,0,0,1,37.71,95.17Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,29.91,184.38a118.15,118.15,0,0,1-4.37-45.33Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,51.55,226.86a123.74,123.74,0,0,1-21.64-42.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,85.65,257a117.93,117.93,0,0,1-34.1-30.17Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,128.3,273a118.16,118.16,0,0,1-42.65-16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94l23.84,122.64a118.23,118.23,0,0,1-45.53.4Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94l66.2,106a118,118,0,0,1-42.36,16.69Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94l99.77,75.19a118,118,0,0,1-33.57,30.76Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94l120.67,32.33a123.61,123.61,0,0,1-20.9,42.86Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94l124.24-13.06a117.86,117.86,0,0,1-3.57,45.39Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,261.3,93.22a118,118,0,0,1,12.93,43.66Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94l83.59-92.85A118,118,0,0,1,261.3,93.22Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94,194.76,33.3a118,118,0,0,1,38.82,23.79Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,149.94V25a118.09,118.09,0,0,1,44.77,8.3Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 18) {
        <g id="_18" data-name="18">
            <path
                class="percentRing-1"
                d="M150,150,107.28,32.54A118.9,118.9,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,69.71,54.24a119,119,0,0,1,37.57-21.7Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,41.83,87.5A119.24,119.24,0,0,1,69.71,54.24Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,27,128.29A119,119,0,0,1,41.83,87.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,27,171.71a119.57,119.57,0,0,1,0-43.42Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,41.83,212.5A119,119,0,0,1,27,171.71Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,69.71,245.76A119.24,119.24,0,0,1,41.83,212.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,107.28,267.46a119,119,0,0,1-37.57-21.7Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275a118.9,118.9,0,0,1-42.72-7.54Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l42.72,117.46A118.9,118.9,0,0,1,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l80.29,95.76a119,119,0,0,1-37.57,21.7Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l108.17,62.5a119.24,119.24,0,0,1-27.88,33.26Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l123,21.71a119,119,0,0,1-14.84,40.79Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l123-21.71a119.57,119.57,0,0,1,0,43.42Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,258.17,87.5A119,119,0,0,1,273,128.29Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l80.29-95.76A119.24,119.24,0,0,1,258.17,87.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,192.72,32.54a119,119,0,0,1,37.57,21.7Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25a118.9,118.9,0,0,1,42.72,7.54Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 19) {
        <g id="_19" data-name="19">
            <path
                class="percentRing-1"
                d="M150,150,109.32,31.81A119.45,119.45,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,73.08,51.49a119.52,119.52,0,0,1,36.24-19.68Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,45.21,81.9A119.25,119.25,0,0,1,73.08,51.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,28.76,119.73A119.7,119.7,0,0,1,45.21,81.9Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,25.52,160.85a119.66,119.66,0,0,1,3.24-41.12Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,35.85,200.79a119.74,119.74,0,0,1-10.33-39.94Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,58.62,235.18a119.42,119.42,0,0,1-22.77-34.39Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,91.34,260.29a119.37,119.37,0,0,1-32.72-25.11Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,130.46,273.38a119.38,119.38,0,0,1-39.12-13.09Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,171.7,273a119.26,119.26,0,0,1-41.24.36Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l60.58,109.29A119.22,119.22,0,0,1,171.7,273Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l92.86,83.61a119.46,119.46,0,0,1-32.28,25.68Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l115,48.83a119.5,119.5,0,0,1-22.16,34.78Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l124.65,8.72A119.54,119.54,0,0,1,265,198.79Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l120.7-32.34a119.5,119.5,0,0,1,4,41.06Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,253.6,80.08a119.82,119.82,0,0,1,17.11,37.54Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l75.2-99.8A119.49,119.49,0,0,1,253.6,80.08Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,188.62,31.12a119.4,119.4,0,0,1,36.59,19Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25a113.15,113.15,0,0,1,38.61,6.12Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (distribution === 20) {
        <g id="_20" data-name="20">
            <path
                class="percentRing-1"
                d="M150,150,111.37,31.12A118.74,118.74,0,0,1,150,25Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,76.53,48.87a118.77,118.77,0,0,1,34.84-17.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,48.87,76.53A119.06,119.06,0,0,1,76.53,48.87Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,31.12,111.37A118.77,118.77,0,0,1,48.87,76.53Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H25a118.74,118.74,0,0,1,6.12-38.63Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,31.12,188.63A118.74,118.74,0,0,1,25,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,48.87,223.47a118.77,118.77,0,0,1-17.75-34.84Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,76.53,251.13a119.06,119.06,0,0,1-27.66-27.66Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,111.37,268.88a118.77,118.77,0,0,1-34.84-17.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V275a118.74,118.74,0,0,1-38.63-6.12Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l38.63,118.88A118.74,118.74,0,0,1,150,275Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l73.47,101.13a118.77,118.77,0,0,1-34.84,17.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l101.13,73.47a119.06,119.06,0,0,1-27.66,27.66Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l118.88,38.63a118.77,118.77,0,0,1-17.75,34.84Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150H275a118.74,118.74,0,0,1-6.12,38.63Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150l118.88-38.63A118.74,118.74,0,0,1,275,150Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,251.13,76.53a118.77,118.77,0,0,1,17.75,34.84Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,223.47,48.87a119.06,119.06,0,0,1,27.66,27.66Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150,188.63,31.12a118.77,118.77,0,0,1,34.84,17.75Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-1"
                d="M150,150V25a118.74,118.74,0,0,1,38.63,6.12Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (showUnits) {
        <g id="_100_verdeling" data-name="100 verdeling">
            <path
                class="percentRing-2"
                d="M70.13,246.16l.38.31,3.19-3.85-.38-.32Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M53.53,229.49l.32.38,3.85-3.19c-.11-.13-.22-.25-.32-.38Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M58.71,235.39l.34.36,3.65-3.43-.34-.36Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M64.25,241l.36.34L68,237.64l-.36-.34Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M82.81,255.41l.42.26,2.68-4.21-.43-.26Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M76.32,251l.41.29,2.94-4-.41-.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M126.33,272.74l.49.09.94-4.9-.49-.09Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M111.14,268.8l.47.16,1.54-4.73-.48-.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M103.75,266.13l.47.18,1.83-4.62-.47-.18Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M96.55,263l.45.21,2.12-4.51-.45-.21Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M89.56,259.42l.44.24,2.4-4.37-.44-.24Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M25.23,157.6l0,.5,5-.32,0-.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M26,165.42l.07.5,4.95-.63c0-.17,0-.33-.06-.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M134.09,274l.49.07.63-5-.5,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M27.17,173.18l.09.49,4.9-.94-.09-.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M26,134.09l-.07.49,5,.63c0-.17,0-.33.05-.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M48.73,223.27l.29.41,4-2.94-.3-.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M28.87,180.84l.12.49,4.82-1.24c-.05-.16-.08-.32-.13-.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M25.26,141.9l0,.5,5,.32,0-.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M40.34,210l.24.44L45,208l-.24-.44Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M31,188.39l.16.47,4.73-1.53c0-.16-.1-.32-.16-.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M44.33,216.77l.26.42,4.21-2.67-.26-.43Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M36.79,203l.21.45,4.51-2.12-.21-.45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M33.69,195.78l.18.47,4.62-1.83-.18-.47Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M118.67,271l.49.13,1.23-4.82-.48-.13Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M259.42,210.44l.24-.44-4.37-2.4-.24.44Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M263,203.45l.21-.45-4.51-2.12-.21.45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M255.41,217.19l.26-.42-4.21-2.68-.26.43Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M266.13,196.25l.18-.47L261.69,194l-.18.47Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M246.16,229.87l.31-.38-3.85-3.19c-.1.13-.21.25-.32.38Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M251,223.68l.29-.41-4-2.94-.3.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M141.9,274.74l.5,0,.32-5-.5,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M241,235.75l.34-.36L237.64,232l-.34.36Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M274,165.92l.07-.5-5-.63c0,.17,0,.33,0,.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M27.26,126.33l-.09.49,4.9.94.09-.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M271,181.33l.13-.49-4.82-1.23c-.05.16-.08.32-.13.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M274.74,158.1l0-.5-5-.31,0,.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M268.8,188.86l.16-.47-4.73-1.54c-.06.16-.11.32-.16.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M195.78,266.31l.47-.18-1.83-4.62-.47.18Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M173.18,272.83l.49-.09-.94-4.9-.49.09Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M188.39,269l.47-.16-1.53-4.73-.48.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M180.84,271.14l.49-.13-1.24-4.82-.48.13Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M235.39,241.29l.36-.34-3.43-3.65-.36.34Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M157.6,274.77l.5,0-.32-5-.49,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M165.42,274.05l.5-.07-.63-4.94-.5,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M229.49,246.47l.38-.31-3.19-3.86-.38.32Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M223.27,251.27l.41-.29-2.94-4-.41.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M203,263.21l.45-.21-2.12-4.51-.45.21Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M210,259.66l.44-.24-2.4-4.37-.44.24Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M216.77,255.67l.42-.26-2.67-4.21-.43.26Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M272.74,173.67l.09-.49-4.9-.94-.09.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M241.29,64.61l-.34-.36-3.65,3.43.34.36Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M229.87,53.85l-.38-.32-3.19,3.85.38.32Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M235.75,59.05l-.36-.34L232,62.36l.36.34Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M246.47,70.51l-.31-.38-3.86,3.19c.11.13.22.25.32.38Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M188.86,31.2l-.47-.16-1.54,4.73.48.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M255.67,83.23l-.26-.42-4.21,2.67.26.43Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M223.68,49l-.41-.29-2.94,4,.41.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M196.25,33.87l-.47-.18L194,38.31l.47.18Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M203.45,37l-.45-.21-2.12,4.51.45.21Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M259.66,90l-.24-.44L255.05,92l.24.44Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M210.44,40.58l-.44-.24-2.4,4.37L208,45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M217.19,44.59l-.42-.26-2.68,4.21.43.26Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M251.27,76.73l-.29-.41-4,2.94.3.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M150.25,30V25h-.5v5h.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M270,150.25h5v-.5h-5v.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M30,149.75H25v.5h5v-.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M149.75,270v5h.5v-5h-.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M274.77,142.4l0-.5-5,.32,0,.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M266.31,104.22l-.18-.47-4.62,1.83.18.47Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M269,111.61l-.16-.47-4.73,1.53c.05.16.1.32.16.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M263.21,97l-.21-.45-4.51,2.12.21.45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M274.05,134.58l-.07-.49-4.94.62c0,.17,0,.33,0,.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M29,118.67l-.12.49,4.81,1.23c0-.16.08-.32.13-.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M272.83,126.82l-.09-.49-4.9.94.09.49Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M271.14,119.16l-.13-.49-4.82,1.24c.05.16.08.32.13.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M59.05,64.25l-.34.36L62.36,68l.34-.36Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M64.61,58.71l-.36.34,3.43,3.65.36-.34Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M49,76.32l-.29.41,4,2.94.3-.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M53.85,70.13l-.32.38,3.85,3.19c.1-.13.21-.25.32-.38Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M83.23,44.33l-.42.26,2.67,4.21.43-.26Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M70.51,53.53l-.38.32,3.19,3.85.38-.32Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M76.73,48.73l-.41.29,2.94,4,.41-.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M181.33,29l-.49-.12-1.23,4.81.48.13Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M31.2,111.14l-.16.47,4.73,1.54c.06-.16.11-.32.16-.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M44.59,82.81l-.26.42,4.21,2.68.26-.43Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M37,96.55l-.21.45,4.51,2.12.21-.45Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M40.58,89.56l-.24.44,4.37,2.4L45,92Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M33.87,103.75l-.18.47,4.62,1.83.18-.47Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M158.1,25.26l-.5,0-.31,5,.49,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M142.4,25.23l-.5,0,.32,5,.5,0Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M173.67,27.26l-.49-.09-.94,4.9.49.09Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M134.58,26l-.49.07.62,4.94.5-.05Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M165.92,26l-.5-.07-.63,5,.5.06Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M126.82,27.17l-.49.09.94,4.9.49-.09Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M97,36.79l-.45.21,2.12,4.51.45-.21Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M104.22,33.69l-.47.18,1.83,4.62.47-.18Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M119.16,28.87l-.49.12,1.24,4.82.48-.13Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M111.61,31l-.47.16,1.53,4.73.48-.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M90,40.34l-.44.24L92,45l.44-.24Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (showNumbers) {
        <g id="_20_verdeling" data-name="20 verdeling">
            <path
                class="percentRing-2"
                d="M76.32,251l.41.29,2.94-4-.41-.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M111.14,268.8l.47.16,1.54-4.73-.48-.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M48.73,223.27l.29.41,4-2.94-.3-.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M31,188.39l.16.47,4.73-1.53c0-.16-.1-.32-.16-.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M251,223.68l.29-.41-4-2.94-.3.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M268.8,188.86l.16-.47-4.73-1.54c-.06.16-.11.32-.16.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M188.39,269l.47-.16-1.53-4.73-.48.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M223.27,251.27l.41-.29-2.94-4-.41.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M188.86,31.2l-.47-.16-1.54,4.73.48.16Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M223.68,49l-.41-.29-2.94,4,.41.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M251.27,76.73l-.29-.41-4,2.94.3.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M150.25,30V25h-.5v5h.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M270,150.25h5v-.5h-5v.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M30,149.75H25v.5h5v-.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M149.75,270v5h.5v-5h-.5Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M269,111.61l-.16-.47-4.73,1.53c.05.16.1.32.16.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M49,76.32l-.29.41,4,2.94.3-.41Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M76.73,48.73l-.41.29,2.94,4,.41-.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M31.2,111.14l-.16.47,4.73,1.54c.06-.16.11-.32.16-.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                class="percentRing-2"
                d="M111.61,31l-.47.16,1.53,4.73.48-.16Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        } @if (showNumbers) {
        <g id="Getallen">
            <path
                d="M189.2,23.88A1.67,1.67,0,0,0,191,25.45a2.28,2.28,0,0,0,2.19-2.55c0-1.5-.82-2.38-2.1-2.38a1.93,1.93,0,0,0-2,1.5h-1.45l.28-6.59h6.23v1.29h-4.85l-.21,3.59a3.12,3.12,0,0,1,2.34-1c2.22,0,3.31,1.75,3.31,3.65a3.71,3.71,0,0,1-3.95,3.83,3,3,0,0,1-3.3-2.88Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M228.05,37.08a14.17,14.17,0,0,1-2.58,1.6v-1.6a16.52,16.52,0,0,0,2.69-1.75h1.42V46.41h-1.53Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M236.14,35.11c3.32,0,3.72,3.55,3.72,5.63,0,2.63-.53,4.1-1.54,5a3.2,3.2,0,0,1-2.21.85,3.23,3.23,0,0,1-3-1.84,8,8,0,0,1-.72-3.79C232.43,39.35,232.62,35.11,236.14,35.11Zm0,10.19c1.85,0,2.17-2.43,2.17-4.41,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.19,2.54-2.19,4.53C234,43.38,234.45,45.3,236.13,45.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M257.35,67.24a13.15,13.15,0,0,1-2.58,1.6v-1.6a15.9,15.9,0,0,0,2.69-1.74h1.42V76.57h-1.53Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M264.22,74a1.69,1.69,0,0,0,1.85,1.57A2.28,2.28,0,0,0,268.26,73c0-1.5-.82-2.38-2.1-2.38a1.93,1.93,0,0,0-2,1.5H262.7L263,65.5h6.23v1.29h-4.85l-.21,3.59a3.12,3.12,0,0,1,2.34-1c2.22,0,3.31,1.74,3.31,3.65a3.72,3.72,0,0,1-3.95,3.82,3,3,0,0,1-3.3-2.88Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M274.78,111.69l2.9-2.85a15.29,15.29,0,0,0,1.71-1.9,3.16,3.16,0,0,0,.82-2,1.66,1.66,0,0,0-1.78-1.81,1.72,1.72,0,0,0-1.81,1.94h-1.68a3.15,3.15,0,0,1,1-2.44,3.66,3.66,0,0,1,2.4-.8,3.1,3.1,0,0,1,3.42,3.24c0,.7,0,1.25-1.25,2.77-.32.4-1.72,1.85-2,2.17l-1.94,1.84h5.27v1.27h-7.05Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M287.25,101.85c3.31,0,3.71,3.55,3.71,5.63,0,2.63-.53,4.1-1.54,5a3.19,3.19,0,0,1-2.2.85,3.25,3.25,0,0,1-3-1.84,8.14,8.14,0,0,1-.72-3.79C283.53,106.09,283.73,101.85,287.25,101.85Zm0,10.19c1.86,0,2.18-2.43,2.18-4.41,0-2.66-.47-4.5-2.15-4.5-1.93,0-2.19,2.54-2.19,4.53C285.07,110.12,285.55,112,287.23,112Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M280.12,153l2.9-2.85a17.06,17.06,0,0,0,1.71-1.9,3.13,3.13,0,0,0,.81-2,1.65,1.65,0,0,0-1.77-1.81,1.71,1.71,0,0,0-1.81,1.94h-1.68a3.1,3.1,0,0,1,1-2.44,3.68,3.68,0,0,1,2.4-.8c1.7,0,3.43.87,3.43,3.24,0,.7-.05,1.24-1.25,2.76-.32.41-1.73,1.86-2.05,2.18l-1.93,1.84h5.26v1.27h-7Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M290.73,151.79a1.68,1.68,0,0,0,1.84,1.57,2.27,2.27,0,0,0,2.19-2.54c0-1.51-.82-2.39-2.1-2.39a2,2,0,0,0-1.48.58,2,2,0,0,0-.52.93h-1.45l.29-6.6h6.22v1.3h-4.85l-.21,3.58a3.15,3.15,0,0,1,2.34-1c2.23,0,3.31,1.74,3.31,3.65a3.71,3.71,0,0,1-3.95,3.82,3,3,0,0,1-3.3-2.88Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M276.24,193.73c0,1.06.67,1.81,2,1.81a2,2,0,0,0,2.21-2,1.92,1.92,0,0,0-1.6-1.95,6.69,6.69,0,0,0-1.54-.08v-1.29c1.11.09,3-.13,3-1.93,0-1.24-.84-1.74-1.95-1.74a1.86,1.86,0,0,0-2,1.74h-1.61c.09-2.75,2.69-3,3.58-3,2.42,0,3.62,1.45,3.62,3a2.62,2.62,0,0,1-2.21,2.61,2.61,2.61,0,0,1,2.37,2.69c0,1.55-1.26,3.27-3.84,3.27a4,4,0,0,1-3-1.16,2.88,2.88,0,0,1-.66-2Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M287.25,185.28c3.31,0,3.71,3.56,3.71,5.64,0,2.62-.53,4.09-1.54,5a3.19,3.19,0,0,1-2.2.85,3.26,3.26,0,0,1-3-1.84,8.19,8.19,0,0,1-.72-3.8C283.53,189.52,283.73,185.28,287.25,185.28Zm0,10.2c1.86,0,2.18-2.43,2.18-4.42,0-2.66-.47-4.5-2.15-4.5-1.93,0-2.19,2.55-2.19,4.53C285.07,193.56,285.55,195.48,287.23,195.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M256.07,233.4c0,1.06.68,1.81,2,1.81a2,2,0,0,0,2.21-2,1.91,1.91,0,0,0-1.61-2,6.08,6.08,0,0,0-1.53-.08v-1.3c1.1.1,3-.13,3-1.92,0-1.25-.85-1.74-1.95-1.74a1.85,1.85,0,0,0-2,1.74h-1.62c.1-2.75,2.69-3,3.59-3,2.42,0,3.62,1.46,3.62,3a2.64,2.64,0,0,1-2.21,2.61,2.6,2.6,0,0,1,2.37,2.69c0,1.55-1.27,3.26-3.85,3.26a4,4,0,0,1-3-1.15,2.87,2.87,0,0,1-.65-2Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M265.23,233.62a1.67,1.67,0,0,0,1.84,1.57,2.27,2.27,0,0,0,2.19-2.54c0-1.51-.82-2.39-2.1-2.39a1.95,1.95,0,0,0-2,1.51h-1.45l.28-6.6h6.23v1.3h-4.85l-.21,3.59a3.12,3.12,0,0,1,2.34-1c2.22,0,3.31,1.75,3.31,3.65a3.71,3.71,0,0,1-3.95,3.83,3,3,0,0,1-3.3-2.89Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M228.38,263h-5v-1.91l4.81-6.91h1.73v7.52h1.61V263h-1.61v2.4h-1.54Zm.05-1.3v-5.84l-3.83,5.84Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M236.25,254.12c3.31,0,3.71,3.55,3.71,5.63,0,2.63-.53,4.1-1.53,5a3.3,3.3,0,0,1-5.17-1,8,8,0,0,1-.72-3.79C232.54,258.36,232.73,254.12,236.25,254.12Zm0,10.19c1.86,0,2.18-2.43,2.18-4.42,0-2.65-.46-4.49-2.14-4.49-1.94,0-2.2,2.54-2.2,4.53C234.07,262.39,234.55,264.31,236.23,264.31Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M189.54,282.52h-5v-1.91l4.8-6.91h1.73v7.52h1.62v1.3h-1.62v2.4h-1.54Zm.05-1.3v-5.84l-3.82,5.84Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M195.56,282.29a1.68,1.68,0,0,0,1.84,1.57,2.26,2.26,0,0,0,2.19-2.54c0-1.51-.81-2.39-2.09-2.39a2.05,2.05,0,0,0-1.49.58,2,2,0,0,0-.51.92H194l.29-6.59h6.22v1.3H195.7l-.2,3.58a3.13,3.13,0,0,1,2.33-1c2.23,0,3.32,1.74,3.32,3.65a3.72,3.72,0,0,1-4,3.82,3,3,0,0,1-3.3-2.88Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M143.92,288.62a1.67,1.67,0,0,0,1.84,1.57,2.27,2.27,0,0,0,2.19-2.54c0-1.51-.82-2.39-2.1-2.39a1.95,1.95,0,0,0-2,1.51H142.4l.28-6.6h6.23v1.3h-4.85l-.21,3.59a3.12,3.12,0,0,1,2.34-1c2.22,0,3.31,1.75,3.31,3.65a3.71,3.71,0,0,1-3.95,3.83,3,3,0,0,1-3.3-2.89Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M154.67,280c3.31,0,3.71,3.55,3.71,5.63,0,2.63-.53,4.1-1.54,5.05a3.31,3.31,0,0,1-5.17-1,8.14,8.14,0,0,1-.72-3.79C151,284.19,151.15,280,154.67,280Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.47-4.5-2.15-4.5-1.93,0-2.19,2.54-2.19,4.53C152.49,288.22,153,290.15,154.65,290.15Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M98.33,282.29a1.68,1.68,0,0,0,1.84,1.57,2.27,2.27,0,0,0,2.2-2.54c0-1.51-.82-2.39-2.1-2.39a2.07,2.07,0,0,0-1.49.58,2,2,0,0,0-.51.92H96.81l.29-6.59h6.23v1.3H98.48l-.21,3.58a3.13,3.13,0,0,1,2.33-1c2.23,0,3.32,1.74,3.32,3.65a3.72,3.72,0,0,1-4,3.82,3,3,0,0,1-3.29-2.88Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M107.23,282.29a1.68,1.68,0,0,0,1.84,1.57,2.27,2.27,0,0,0,2.19-2.54c0-1.51-.82-2.39-2.1-2.39a2,2,0,0,0-1.48.58,2,2,0,0,0-.52.92h-1.45l.29-6.59h6.22v1.3h-4.85l-.21,3.58a3.15,3.15,0,0,1,2.34-1c2.23,0,3.31,1.74,3.31,3.65a3.71,3.71,0,0,1-4,3.82,3,3,0,0,1-3.3-2.88Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M64.37,257a1.55,1.55,0,0,0-1.68-1.64c-1.6,0-2.3,1.37-2.45,4.32a2.81,2.81,0,0,1,2.58-1.41,3.24,3.24,0,0,1,3.34,3.55,3.65,3.65,0,0,1-3.74,3.88,3.52,3.52,0,0,1-2.74-1.2,7,7,0,0,1-1-4.08c0-2.42.6-6.26,4.1-6.26a3.51,3.51,0,0,1,2.66,1A2.71,2.71,0,0,1,66,257Zm.26,5c0-.79-.23-2.47-2.07-2.47a2.51,2.51,0,0,0-.08,5A2.21,2.21,0,0,0,64.63,261.93Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M71.17,254.12c3.31,0,3.71,3.55,3.71,5.63,0,2.63-.52,4.1-1.53,5a3.3,3.3,0,0,1-5.17-1,8,8,0,0,1-.72-3.79C67.46,258.36,67.65,254.12,71.17,254.12Zm0,10.19c1.86,0,2.18-2.43,2.18-4.42,0-2.65-.46-4.49-2.14-4.49-1.94,0-2.2,2.54-2.2,4.53C69,262.39,69.47,264.31,71.15,264.31Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M34.25,227.8a1.55,1.55,0,0,0-1.68-1.65c-1.6,0-2.3,1.38-2.45,4.32a2.82,2.82,0,0,1,2.58-1.41,3.25,3.25,0,0,1,3.35,3.56,3.64,3.64,0,0,1-3.75,3.87,3.5,3.5,0,0,1-2.74-1.2,7,7,0,0,1-1-4.08c0-2.42.59-6.26,4.09-6.26A3.45,3.45,0,0,1,35.31,226a2.64,2.64,0,0,1,.59,1.79Zm.26,5c0-.78-.22-2.47-2.06-2.47a2.51,2.51,0,0,0-.08,5A2.21,2.21,0,0,0,34.51,232.76Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M39.2,233.62A1.67,1.67,0,0,0,41,235.19a2.27,2.27,0,0,0,2.19-2.54c0-1.51-.82-2.39-2.1-2.39a1.95,1.95,0,0,0-2,1.51H37.68l.28-6.6h6.23v1.3H39.34l-.21,3.59a3.12,3.12,0,0,1,2.34-1c2.22,0,3.31,1.75,3.31,3.65a3.71,3.71,0,0,1-4,3.83,3,3,0,0,1-3.3-2.89Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M9.33,185.51h7.32v1.34l-4.07,9.73H10.77L15,186.84H9.33Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M22.08,185.28c3.32,0,3.72,3.56,3.72,5.64,0,2.62-.53,4.09-1.54,5a3.2,3.2,0,0,1-2.21.85,3.25,3.25,0,0,1-3-1.84,8.06,8.06,0,0,1-.72-3.8C18.37,189.52,18.56,185.28,22.08,185.28Zm0,10.2c1.85,0,2.18-2.43,2.18-4.42,0-2.66-.47-4.5-2.15-4.5-1.94,0-2.19,2.55-2.19,4.53C19.91,193.56,20.39,195.48,22.07,195.48Z"
                transform="translate(-3.44 -8.7)"
            />
            <text class="percentRing-3" transform="translate(0 145.72)">
                75
            </text>
            <path
                d="M10.25,104.84c0-1,.68-3,3.59-3,2.34,0,3.68,1.26,3.68,3a2.54,2.54,0,0,1-2.26,2.51,2.81,2.81,0,0,1,2.42,2.8c0,1.52-1.06,3.25-3.81,3.25a4.17,4.17,0,0,1-2.86-.93,3,3,0,0,1-1-2.22,2.84,2.84,0,0,1,.85-2,3.61,3.61,0,0,1,1.6-.84A2.57,2.57,0,0,1,10.25,104.84Zm3.62,7.24a2.06,2.06,0,1,0,0-4.12A2.09,2.09,0,0,0,11.65,110,2,2,0,0,0,13.87,112.08Zm0-9.08a1.82,1.82,0,1,0,0,3.6A1.89,1.89,0,0,0,16,104.81,1.85,1.85,0,0,0,13.9,103Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M22.75,101.85c3.31,0,3.71,3.55,3.71,5.63,0,2.63-.52,4.1-1.53,5a3.3,3.3,0,0,1-5.17-1,8,8,0,0,1-.72-3.79C19,106.09,19.23,101.85,22.75,101.85Zm0,10.19c1.85,0,2.17-2.43,2.17-4.41,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.54-2.2,4.53C20.57,110.12,21.05,112,22.74,112Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M27.85,68.27c0-1,.67-3,3.58-3,2.34,0,3.69,1.27,3.69,3a2.56,2.56,0,0,1-2.26,2.52,2.8,2.8,0,0,1,2.42,2.8c0,1.52-1.06,3.25-3.81,3.25a4.23,4.23,0,0,1-2.87-.93,3.12,3.12,0,0,1-1-2.23,2.83,2.83,0,0,1,.85-2,3.58,3.58,0,0,1,1.6-.85A2.56,2.56,0,0,1,27.85,68.27Zm3.62,7.23a2.06,2.06,0,1,0,0-4.11,2.1,2.1,0,0,0-2.26,2.08A2,2,0,0,0,31.47,75.5Zm0-9.07a1.82,1.82,0,1,0-.05,3.6,1.9,1.9,0,0,0,2.13-1.79A1.85,1.85,0,0,0,31.5,66.43Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M38.49,74a1.68,1.68,0,0,0,1.84,1.57A2.27,2.27,0,0,0,42.52,73c0-1.5-.81-2.38-2.09-2.38a2.09,2.09,0,0,0-1.49.57,2,2,0,0,0-.51.93H37l.29-6.59h6.22v1.29H38.63l-.2,3.59a3.09,3.09,0,0,1,2.33-1c2.23,0,3.32,1.74,3.32,3.65a3.72,3.72,0,0,1-4,3.82A3,3,0,0,1,36.82,74Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M58.77,43.77c0,1,.53,1.63,1.78,1.63,2.43,0,2.45-2.87,2.37-4.59a2.69,2.69,0,0,1-2.48,1.39,3.28,3.28,0,0,1-3.38-3.51,3.35,3.35,0,0,1,3.55-3.57,3.51,3.51,0,0,1,3.57,2.72,10.1,10.1,0,0,1,.32,3c0,1.63,0,5.84-4.08,5.84-1.5,0-3.26-.59-3.33-2.89Zm1.84-7.45c-1.29,0-2,1.08-2,2.39A2,2,0,0,0,60.73,41a2,2,0,0,0,2-2.25A2.17,2.17,0,0,0,60.61,36.32Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M69.67,35.11c3.31,0,3.71,3.55,3.71,5.63,0,2.63-.52,4.1-1.53,5a3.3,3.3,0,0,1-5.17-1A8,8,0,0,1,66,41C66,39.35,66.15,35.11,69.67,35.11Zm0,10.19c1.86,0,2.18-2.43,2.18-4.41,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.54-2.2,4.53C67.49,43.38,68,45.3,69.65,45.3Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M97.19,23.86A1.54,1.54,0,0,0,99,25.5c2.44,0,2.45-2.87,2.37-4.6a2.65,2.65,0,0,1-2.48,1.39,3.27,3.27,0,0,1-3.38-3.5A3.34,3.34,0,0,1,99,15.22a3.52,3.52,0,0,1,3.57,2.72,10.36,10.36,0,0,1,.32,3c0,1.63,0,5.84-4.08,5.84-1.51,0-3.27-.59-3.33-2.9ZM99,16.42c-1.3,0-2,1.07-2,2.38a2.05,2.05,0,0,0,2.1,2.28,2,2,0,0,0,2-2.26A2.17,2.17,0,0,0,99,16.42Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M106.23,23.88a1.68,1.68,0,0,0,1.84,1.57,2.28,2.28,0,0,0,2.19-2.55c0-1.5-.82-2.38-2.1-2.38a2,2,0,0,0-2,1.5h-1.45l.29-6.59h6.22v1.29h-4.85l-.21,3.59a3.12,3.12,0,0,1,2.34-1c2.23,0,3.31,1.75,3.31,3.65a3.71,3.71,0,0,1-4,3.83,3,3,0,0,1-3.3-2.88Z"
                transform="translate(-3.44 -8.7)"
            />
            <path
                d="M150,8.7c3.31,0,3.71,3.55,3.71,5.63,0,2.63-.52,4.1-1.53,5a3.31,3.31,0,0,1-5.17-1,8,8,0,0,1-.72-3.79C146.27,12.94,146.46,8.7,150,8.7Zm0,10.2c1.86,0,2.18-2.44,2.18-4.42,0-2.66-.46-4.5-2.14-4.5-1.94,0-2.2,2.54-2.2,4.53C147.8,17,148.28,18.9,150,18.9Z"
                transform="translate(-3.44 -8.7)"
            />
        </g>
        }
    </svg>
</ng-template>
